import { type CollectionDefinition } from '@clubspark-node/clubspark-tennis-types';

export interface PrimaryLocationInterface {
  name?: string;
  county: string;
  town: string;
}
export interface TimingsInterface {
  endDate: string;
  startDate: string;
  startDateTime: string;
  endDateTime: string;
  timeZone: string;
}
export interface Organisation {
  id: string;
  urlSegment: string;
}
export interface TournamentUrlsResponse {
  tournamentUrls?: TournamentUrls;
}
export interface TournamentUrls {
  publicSite?: string;
  adminArea?: string;
  webInfo?: string;
  tournamentSettings?: string;
}
export interface TournamentInterface {
  tournamentId: string;
  tournamentName: string;
  organisation: Organisation;
  primaryLocation: PrimaryLocationInterface;
  restrictedToLevelId: string;
  startDate?: string;
  endDate?: string;
}
export interface PaginatedTournamentsInterface {
  items: TournamentInterface[];
  totalItems: number;
}
export interface PaginatedTournamentsObjectInterface {
  paginatedTournaments: PaginatedTournamentsInterface;
}
export interface PaginatedTournamentsResponseInterface {
  data: PaginatedTournamentsObjectInterface;
}
export interface PaginationSort {
  property: string;
  sortDirection: string;
}
export interface PaginationFilter {
  operator: string;
  property: string;
  values: string[];
}
export interface DraftTournamentsPaginatedVariables {
  limit: number;
  offset: number;
  sorts: PaginationSort[];
  filters: PaginationFilter[];
}
export interface DraftTournamentsFiltersVariables {
  completionStatus?: TournamentCompletionStatus;
  identificationCode?: string;
  nameSearch?: string;
}
export interface LinkableTournament {
  id: string;
  name: string;
  timings: {
    startDate?: Date;
    endDate?: Date;
  };
  level: {
    id?: string;
    name: string;
  };
}

export interface SaveTournamentResult {
  mutateTournament: { success: boolean; error?: any };
}

// TDv2: item of tournament list table
export enum TournamentCompletionStatus {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export enum PillStatusEnum {
  REGISTRATION_OPEN = 'REGISTRATION_OPEN',
  REGISTRATION_CLOSED = 'REGISTRATION_CLOSED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export interface RegistrationRestriction {
  entriesOpenDateTime?: string;
  entriesCloseDateTime: string;
  timeZone: string;
}

interface LevelInterface {
  id: string;
  name: string;
}

export interface TournamentListItemInterface extends TournamentNameIconInterface {
  timings: TimingsInterface;
  approvedEventCount: number;
  uniqueRegistrationsCount: number;
  primaryLocation: PrimaryLocationInterface;
  registrationRestrictions?: RegistrationRestriction;
}

export interface TournamentNameIconInterface {
  id: string;
  identificationCode: string;
  name: string;
  level: LevelInterface;
  websiteContent: {
    logoPath: string;
  };
}

export enum UserTournamentRole {
  ORGANISATION_ADMIN = 'ORGANISATION_ADMIN',
  REGIONAL_ADMIN = 'REGIONAL_ADMIN',
  GLOBAL_ADMIN = 'GLOBAL_ADMIN',
  TOURNAMENT_DIRECTOR = 'TOURNAMENT_DIRECTOR',
  REFEREE = 'REFEREE',
  TOURNAMENT_ASSISTANT = 'TOURNAMENT_ASSISTANT',
  NONE = 'NONE',
}

export interface TournamentRolesInterface {
  isRegionalStaffAdmin: boolean;
  isOrganisationAdmin: boolean;
  activeRole: UserTournamentRole;
  isReferee: boolean;
  isTournamentDirector: boolean;
  isTournamentAssistant: boolean;
  isGlobalAdmin: boolean;
  isStaffAdmin: boolean;
}

export interface TournamentRolesResponseInterface {
  tournamentRoles: TournamentRolesInterface;
}

enum ConfigType {
  RAW = 'RAW',
  RESOLVED = 'RESOLVED',
}

export interface OrgConfig {
  organisationId: string;
  configType: ConfigType;
  tieFormatTemplates?: OrgTieFormat[];
}

export interface OrgTieFormat {
  templateName: string;
  templateId: string;
  matchCollection: CollectionDefinition[];
}

export interface TournamentOrgConfigInterface {
  resolved?: OrgConfig;
}
